import React from 'react'
import PropTypes from 'prop-types'

const IntegrationIcon = ({ style, className, width = 20, height = 20 }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox="0 0 80 90"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    overflow="hidden"
  >
    <defs>
      <clipPath id="clip0">
        <rect x="386" y="476" width="96" height="102" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0)" transform="translate(-386 -476)">
      <path
        d="M30.38 70.62 7.76 48 29.88 25.88 34.12 30.12 16.24 48 34.62 66.38 30.38 70.62Z"
        fill="#FFFFFF"
        transform="matrix(1 0 0 1.0625 386 476)"
      />
      <path
        d="M65.12 70.62 60.88 66.38 79.26 48 61.38 30.12 65.62 25.88 87.74 48 65.12 70.62Z"
        fill="#FFFFFF"
        transform="matrix(1 0 0 1.0625 386 476)"
      />
      <path
        d="M53 48C53 50.7614 50.7614 53 48 53 45.2386 53 43 50.7614 43 48 43 45.2386 45.2386 43 48 43 50.7614 43 53 45.2386 53 48Z"
        fill="#FFFFFF"
        transform="matrix(1 0 0 1.0625 386 476)"
      />
      <path
        d="M37 48C37 50.7614 34.7614 53 32 53 29.2386 53 27 50.7614 27 48 27 45.2386 29.2386 43 32 43 34.7614 43 37 45.2386 37 48Z"
        fill="#FFFFFF"
        transform="matrix(1 0 0 1.0625 386 476)"
      />
      <path
        d="M69 48C69 50.7614 66.7614 53 64 53 61.2386 53 59 50.7614 59 48 59 45.2386 61.2386 43 64 43 66.7614 43 69 45.2386 69 48Z"
        fill="#FFFFFF"
        transform="matrix(1 0 0 1.0625 386 476)"
      />
    </g>
  </svg>
)

IntegrationIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default IntegrationIcon
